import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import { useHMapContext } from '../hooks/useHMapContext';
import HMapCheckbox from '../components/HMapCheckbox';

const HMapDataZoneList = () => {
  const classes = useStyles();
  const { allGeoZoneList, geoZoneStateInfo, heatmapGeoZoneList } =
    useHMapContext();
  const [allGeoZones] = allGeoZoneList;
  const [geoZoneState] = geoZoneStateInfo;
  const { 1: setHeatmapGeoZone } = heatmapGeoZoneList;

  const handleDataZoneCheck = (checked, props) => {
    setHeatmapGeoZone((prev) =>
      !!checked ? [...prev, props.id] : prev.filter((item) => item !== props.id)
    );
  };

  const hasGeoZones = useMemo(
    () => geoZoneState && allGeoZones !== 'loading',
    [geoZoneState, allGeoZones]
  );

  return (
    <>
      {hasGeoZones && (
        <div className={classes.root}>
          {allGeoZones.map((item, idx) => (
            <HMapCheckbox
              key={`dataZoneList_${idx}`}
              id={`${item.id}`}
              label={item.name}
              fontSize="small"
              width="100px"
              onClick={handleDataZoneCheck}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default React.memo(HMapDataZoneList);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '150px',
    backgroundColor: 'white',
    position: 'absolute',
    zIndex: 10,
    right: 120,
    bottom: 16,
    borderRadius: '5px',
    boxShadow: `1px 2px 5px 0px rgba(0, 0, 0, 0.25)`
  },
  mapListItemRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  mapListItem: {
    width: '100%',
    ...theme.typography.h6,
    '&:hover': {
      cursor: 'pointer'
    }
  }
}));
